import axios from 'axios';
import { assoc, compose, omit } from 'ramda';
import moment from 'moment';

import * as urls from 'constants/urls';
import { SERVER_API_FORMAT, API_FORMAT } from 'constants/dates';

export const getDistributors = () => axios.get(urls.DISTRIBUTORS.stringify());

export const getProjects = () => axios.get(urls.PROJECTS.stringify());
export const postProject = ({ payload }) => axios.post(urls.PROJECTS.stringify(), {
    project: {
        ...payload,
        is_finished: false,
    }
});
export const patchProject = ({ payload }) => axios.patch(urls.PROJECTS.stringify(), {
    project: compose(
        omit(['updated_at', 'status', 'created_at']),
        assoc('finishing_date', moment(payload.finishing_date, SERVER_API_FORMAT).format(API_FORMAT)),
        assoc('is_finished', !!payload.is_finished),
     )(payload),
});

export const getApplications = ({ payload }) => axios.get(urls.APPLICATIONS.stringify({ project: payload }));
export const postApplication = ({ payload }) => {
    const bodyFormData = new FormData();
    const form = omit(['files', 'finishing_date', 'status_specification', 'status'], payload);

    if (payload.files) {
        payload.files.forEach(file =>
            bodyFormData.append('files[]', file)
        );
    }

    bodyFormData.append('data', JSON.stringify({ application: form }));

    return axios.post(urls.APPLICATIONS.stringify(), bodyFormData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};
export const patchApplication = ({ payload }) => {
    
    postApplication({
        payload: compose(
            assoc('application_id', payload.id),
            omit(['updated_at', 'created_at'])
        )(payload)
    });
}

export const postMessage = ({ payload }) => {
    const bodyFormData = new FormData();

    bodyFormData.append('message', payload.values.message);

    if (payload.values.file) {
        bodyFormData.append('attachments[]', payload.values.file)
    }

    return axios.post(urls.MESSAGES.stringify({ application: payload.appId }), bodyFormData);
};

export const getMessages = ({ payload }) => {
    return axios.get(urls.MESSAGES.stringify({ application: payload }))
        .then((data) => {
            if (!data || !data.length) {
                return [];
            }
            return data.slice(0).sort((a, b) => {
                return new Date(a.created_at) - new Date(b.created_at);
            })
        })
};




// WEBPACK FOOTER //
// ./src/actions/httpHandlers/projectsHandlers.js